var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c(
      "div",
      { staticClass: "conteudo-container" },
      [
        _c(
          "el-table",
          { staticClass: "table", attrs: { data: _vm.dadosWithColor } },
          [
            _c("template", { slot: "empty" }, [
              _vm._v("Nenhum processo encontrado.")
            ]),
            _c("el-table-column", {
              attrs: {
                label: "%",
                prop: "nome",
                width: "100",
                formatter: _vm.porcentagem
              }
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tipo de Processo",
                prop: "label",
                align: "left",
                width: "220"
              }
            }),
            _c("el-table-column", {
              attrs: {
                label: "Quantidade de Processos",
                prop: "valor",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("div", { staticClass: "tabela" }, [
                        _c(
                          "div",
                          {
                            staticClass: "content-tabela",
                            style: "--color: " + scope.row.color
                          },
                          [_c("span", [_vm._v(_vm._s(scope.row.valor))])]
                        )
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          2
        ),
        _c("app-plotly", {
          staticClass: "grafico",
          attrs: {
            nomeDiv: "graficoProcessoCadastrados",
            dados: _vm.graficoDados,
            layout: _vm.layout,
            centralizarGrafico: true
          }
        })
      ],
      1
    ),
    _c("span", { staticClass: "total-processos" }, [
      _vm._v("Total de processos: " + _vm._s(_vm.totalDados))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43f3d07b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43f3d07b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/gerais/ConteudoModalProcessosArquivados.vue
// module id = null
// module chunks = 